module.exports = __webpack_public_path__ + "img/section-parralax3.19da7d59.png";